import { put, takeEvery } from "redux-saga/effects";
import {
    CreateDir,
    CreateDirComplete,
    DeleteDir,
    DeleteDirComplete,
    DeleteFootage,
    DeleteFootageComplete,
    DeleteFootageFailed,
    GetDir,
    GetDirComplete,
    RenameDir,
    RenameDirComplete,
    RenameFootage,
    RenameFootageComplete,
    UploadFootage,
    UploadFootageComplete,
} from "../actions/DirectoryActions";
import DirectoryApi from "../apis/DirectoryApi";
import DirectoryEvents from "../events/DirectoryEvents";

// ディレクトリ一覧取得
function* GetDirWorker({ parentId, userId }: ReturnType<typeof GetDir>) {
    const directory: any = yield DirectoryApi.getDir(parentId, userId);
    yield put(GetDirComplete(directory.directoryList, directory.footageList, parentId));
}

// ディレクトリ作成
function* CreateDirWorker({ parentId, name, userId }: ReturnType<typeof CreateDir>) {
    const newDirectory: any = yield DirectoryApi.createDir(parentId, name, userId);
    yield put(CreateDirComplete(newDirectory.directoryList, parentId));
}

// ディレクトリ名変更
function* RenameDirWorker({ parentId, name, userId }: ReturnType<typeof RenameDir>) {
    const renameDirectory: any = yield DirectoryApi.renameDir(parentId, name, userId);
    yield put(RenameDirComplete(renameDirectory.directoryList));
}

// ディレクトリ削除
function* DeleteDirWorker({ id, isForce, userId }: ReturnType<typeof DeleteDir>) {
    const delDirectory: any = yield DirectoryApi.deleteDir(id, false, userId);
    yield put(DeleteDirComplete(delDirectory.directoryList, delDirectory.message));
}

// フッテージアップロード
function* UploadFootageWorker({
    footageFile,
    name,
    directoryId,
    userId,
}: ReturnType<typeof UploadFootage>) {
    yield DirectoryApi.uploadFootage(footageFile, name, directoryId, userId);
    const directory: any = yield DirectoryApi.getDir(directoryId, userId);
    yield put(UploadFootageComplete(directory.directoryList, directory.footageList));
}

// フッテージ名変更
function* RenameFootageWorker({ id, name, userId }: ReturnType<typeof RenameFootage>) {
    const directory: any = yield DirectoryApi.renameFootage(id, name, userId);
    yield put(RenameFootageComplete(directory.directoryList, directory.footageList));
}
// フッテージ削除
function* DeleteFooageWorker({ footageId, userId, directoryId }: ReturnType<typeof DeleteFootage>) {
    const result = yield DirectoryApi.deleteFootage(footageId, userId);
    if (result.message) {
        yield put(DeleteFootageFailed(result.message));
    } else {
        const directory: any = yield DirectoryApi.getDir(directoryId, userId);
        yield put(DeleteFootageComplete(directory.directoryList, directory.footageList));
    }
}

export default function* DirectorySaga() {
    yield takeEvery(DirectoryEvents.GetDirStarted, GetDirWorker);
    yield takeEvery(DirectoryEvents.CreateDirStarted, CreateDirWorker);
    yield takeEvery(DirectoryEvents.RenameDirStarted, RenameDirWorker);
    yield takeEvery(DirectoryEvents.DeleteDirStarted, DeleteDirWorker);
    yield takeEvery(DirectoryEvents.UploadFootageStarted, UploadFootageWorker);
    yield takeEvery(DirectoryEvents.RenameFootageStarted, RenameFootageWorker);
    yield takeEvery(DirectoryEvents.DeleteFootageStarted, DeleteFooageWorker);
}
